import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input, SelectableBlock } from '../../../Elements';
import Option from './Option';

const Venue = ({ contractVariables, textFieldChange, yesNoChange }) => (
  <div>
    <h3>Do you have specific venue requirements for setup?</h3>
    <Option>
      <SelectableBlock
        name='setupInstructionsRequired'
        content='Yes'
        value='yes'
        radio
        checked={contractVariables.setupInstructionsRequired}
        onChange={yesNoChange}
      />
    </Option>
    <Option>
      <SelectableBlock
        name='setupInstructionsRequired'
        content='No'
        value='no'
        radio
        checked={!contractVariables.setupInstructionsRequired}
        onChange={yesNoChange}
      />
    </Option>
    {contractVariables.setupInstructionsRequired &&
      <div>
        <h3>What are your setup requirements?</h3>
        <Input
          name='setupInstructions'
          type='text'
          autoHeight
          required
          validationError='Required'
          value={contractVariables.setupInstructions}
          onChange={textFieldChange}
        />
      </div>
    }
  </div>
);

Venue.propTypes = {
  contractVariables: PropTypes.object.isRequired,
  textFieldChange: PropTypes.func.isRequired,
  yesNoChange: PropTypes.func.isRequired
};

export default Venue;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/TermsBuilder/Venue.js